import {useContext, useEffect, useState} from "react";
import QuizManager, {QuizPlayState} from "../QuizManager";
import {GameHint} from "./GameHint";
import {QuizQuestion} from "./QuizQuestion";
import {QuizAnswersList} from "./QuizAnswersList";
import {NextButton} from "../../Shared/Components/NextButton";
import Score from "../../Shared/Components/Score";
import Footer from "../../Shared/Components/Footer";
import {QuizPlayProps} from "./QuizPlay";
import ThemeContext from "../../Shared/Theme/ThemeContext";
import QuizMap from "./QuizMap";
import useSound from 'use-sound';
import StringFactory from "../Factory/StringFactory";
import {scrollToTop} from "../../Shared/Util/Functions";

export function QuizPlayQuestions(props: QuizPlayProps) {

    const [manager,] = useState<QuizManager>(() => new QuizManager(props.quiz, props.settings))
    const [state, setState] = useState<QuizPlayState>(manager.state())
    const [answerState, setAnswerState] = useState<QuizPlayState>(manager.state())
    const theme = useContext(ThemeContext)
    const question = manager.currentQuestion()

    const [soundGood] = useSound("sounds/good.mp3");
    const [soundWrong] = useSound("sounds/wrong.mp3");

    useEffect(() => {
        scrollToQuestion()
    }, [answerState])

    const scrollToQuestion = () => {
        window.scrollBy({ top: 0 })
        const div = document.querySelector('.quiz-hint.bottom')
        let position = div.getBoundingClientRect()
        window.scrollTo(position.left, position.top + window.scrollY - 20);
    }

    return <div className={"quiz-play " + props.quiz.id + (state.selectedAnswerIndex !== undefined ? " answered" : "")} style={{backgroundImage:'url('+theme.backgroundImage+')'}}>
        <h1>{StringFactory.quizTitle(props.quiz, props.settings)}</h1>
        <GameHint className="top" text={manager.hint()} isCorrect={state.isAnswerCorrect} />
        <div className="wrapper">
            {props.settings.map !== undefined && <QuizMap image={props.settings.map} icons={state.icons} />}
            <div className="quiz-content">
                <QuizQuestion question={question} loaded={ () => scrollToTop() }/>
                <GameHint className="bottom" text={manager.hint()} isCorrect={state.isAnswerCorrect}/>
                <QuizAnswersList answers={question.answers} selected={state.selectedAnswerIndex} onAnswer={index => {
                    manager.answer(index)
                    setState(manager.state())
                    setAnswerState(manager.state())
                    if (manager.state().isAnswerCorrect) { soundGood() } else { soundWrong() }
                }}>
                    {state.selectedAnswerIndex === undefined ? undefined : <NextButton onClick={() => {
                        manager.next() ? setState(manager.state()) : props.onFinish(manager.score())
                    }}/>}
                </QuizAnswersList>
            </div>
        </div>
        <Score data={manager.score()}/>
        <Footer home={props.onCancel}/>
    </div>
}